import { render, staticRenderFns } from "./MyVipActBtn.vue?vue&type=template&id=a9e8aa06&"
import script from "./MyVipActBtn.vue?vue&type=script&lang=js&"
export * from "./MyVipActBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports